<template>
  <div style="height:100%;overflow: auto">
    <span style="font-size: 14px;color: rgba(0, 0, 0, 0.85);font-weight: bold">
      选择时间:
      </span>
    <a-range-picker
        style="width:320px;margin-right:12px"
        v-model="value1"
        show-time
        :change="onChange()"
    />
    <span style="font-size: 14px;color: rgba(0, 0, 0, 0.85);font-weight: bold">
      业务类型:
      </span>
    <a-select
        style="width:250px;margin-right:12px"
        allowClear
        v-model="selectValue"
        placeholder="请选择"
        :change="handleChange()"
    >
      <a-select-option value="node_join">网关加入</a-select-option>
      <a-select-option value="node_login">网关登录</a-select-option>
      <a-select-option value="node_off">网关离线</a-select-option>
      <a-select-option value="channel_connected">通道连接</a-select-option>
      <a-select-option value="channel_disconnected">通道关闭</a-select-option>
      <!--      {this.selectOption.map(item => (-->
      <!--      <a-select-option value={item.value}>{item.name}</a-select-option>-->
      <!--      ))}-->
    </a-select>
    <span style="font-size: 14px;color: rgba(0, 0, 0, 0.85);font-weight: bold;">
      日志信息:
      </span>
    <a-input style="width:250px;margin-right:12px"
             v-model="message"
    >
    </a-input>
    <span v-if="!gatewayCodeProps" style="font-size: 14px;color: rgba(0, 0, 0, 0.85);font-weight: bold;">
      网关编号:
      </span>
    <a-input  v-if="!gatewayCodeProps" style="width:250px;margin-right:12px"
             v-model="gatewayCode"
    >
    </a-input>
    <a-button-group>
      <a-button type="primary" @click="searchList()">
        {{ $t('search') }}
      </a-button>
      <a-button type="primary" @click="clera()" style="margin-left: 3px">
        {{ $t('common_reset') }}
      </a-button>
    </a-button-group>

    <ml-table
              :columns="columns"
              :data-source="gatewatLog"
              :pagination="pagination"
              style="margin-top: 5px;"
              @change="handleTableChange"
              :loading="loading"
    >

    </ml-table>
  </div>
</template>

<script>
import {GetGatewayLogVO, IotExtranetLogServiceProxy} from "@/service-proxies/app-v2/iotmodel-storage.service-proxies";
import dayjs from "dayjs";
const ecsp = new IotExtranetLogServiceProxy()
export default {
  name: "GatewayLog",
  props:{
    gatewayCodeProps:{
      type:String,
      default:''
    }
  },
  data() {
    return {
      rightTableScroll:0,
      value1: undefined,
      message: '',
      gatewayCode:'',
      selectValue: undefined,
      startTime: undefined,
      endTime: undefined,
      gatewatLog: [],
      loading : true,
      pagination: {
        current: 1,
        pageSize: 20,
        total: 0,
        size: "normal",
        showSizeChanger: true,
      },
      columns: [
        {
          title: "时间",
          key: "timestamp",
          dataIndex: "timestamp",
          width: 85,
          customRender: (time) => dayjs(time).format("YYYY-MM-DD HH:mm:ss"),
        },
        {
          title: "业务类型",
          key: "level",
          width: 50,
          dataIndex: "level"
        }, {
          title: "网关编号",
          key: "gatewayCode",
          dataIndex: "gatewayCode",
          width: 80,
        },
        {
          width: 80,
          title: "线程id",
          key: "threadId",
          dataIndex: "threadId"
        }, {
          width: 80,
          title: "链接码",
          key: "connectCode",
          dataIndex: "connectCode"
        }, {
          width: 80,
          title: "pcId",
          key: "pcId",
          dataIndex: "pcId",
          resizable:"true"
        },
        {
          width: 400,
          title: "日志信息",
          key: "message",
          dataIndex: "message"
        },
      ]
    }
  },
  watch:{
    pagination: {
      handler(val) {
        this.pagination.showTotal = (total) => {
          return this.$t('Total…items').replace('{0}', ` ${val.total} `)
        }
      },
      immediate: true
    },
    // gatewayCodeProps(){
    //   console.log("gatewayCodeProps",this.gatewayCodeProps)
    //   this.$nextTick(()=>{this.searchList()})
    // }
  },
  created() {
    this.$nextTick(()=>{this.getTableData()})
  },
  methods: {
    handleChange() {

    },
    searchList() {
      this.pagination.current = 1
      this.getTableData()
    },
    onChange() {
      if (this.value1 && this.value1.length > 0) {
        this.startTime = Date.parse(new Date(this.value1[0]._d)).toString()
        this.endTime = Date.parse(new Date(this.value1[1]._d)).toString()

      }else{
        this.startTime = ''
        this.endTime = ''
      }
    },
    clera() {
      this.value1 = undefined
      this.message = ''
      this.gatewayCode = ''
      this.selectValue = undefined
      this.startTime = ''
      this.endTime = ''
      this.pagination.current = 1
      this.pagination.pageSize = 20
      // this.getTableData()
      this.searchList();
    },
    handleTableChange(e) {
      if (e){
        this.pagination.current = e.current
        this.pagination.pageSize = e.pageSize
      }

      this.getTableData()
    },
    getTableData(){
      this.loading =true
      let sValue = this.selectValue == undefined ? '' : this.selectValue
      let params = {
        current : this.pagination.current,
        size : this.pagination.pageSize,
        level : sValue,
        startTime : this.startTime,
        endTime : this.endTime,
        message :this.message,
        gatewayCode : this.gatewayCodeProps ? this.gatewayCodeProps : this.gatewayCode
      }
      const gs = new GetGatewayLogVO()
      gs.init(params)
      ecsp.getIotGatewayLog(gs).then((res) => {
        if (res){
          this.gatewatLog = res.items
          this.pagination.total = res.totalCount
        }

      }).finally(()=>{
        this.loading = false
      })

    }
  }
}
</script>

<style scoped lang="less">

</style>